import { useContext } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import { translate, translateNumber } from "../../../helper";
import DataTable from "../../common/DataTable";
import "./index.css";

const Party = (props) => {
  const { lang } = useContext(LangContext);

  const constructData = (data) => {
    data = data.filter((p, i) => p.code !== "I");

    data = data.map((p, i) => {
      let symbol = p.code.toUpperCase();

      return {
        sn_en: i + 1,
        sn: <div className="sh-center">{translateNumber(i + 1, lang)}</div>,
        name_en: p.name_en,
        name_np: p.name_np,
        code: p.code.toUpperCase(),
        name: (
          // <a href={"https://google.com/search?q=" + p.name_en} rel="noreferrer" target="_blank">
          //   {p["name_" + lang]}
          // </a>
          <Link to={"/candidates/" + p.code}>{p["name_" + lang]}</Link>
        ),
        president: <a href={"https://google.com/search?q=" + p.president_en} rel="noreferrer" target="_blank">{p["president_" + lang]}</a>,
        president_en: p["president_en"],
        short_name: <Link to={"/candidates/" + p.code}>{p["short_name_" + lang]}</Link>,
        symbol: (
          <div className="sh-table-party-symbol">
            <img
              src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
              alt={p.code.toUpperCase()}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
              }}
            />
          </div>
        ),
        color: <div className="sh-table-party-color" style={{ backgroundColor: p.color }}></div>,
      };
    });
    return data;
  };

  const data = constructData(props.data);
  const headers = [
    { title: translate("sn", lang), prop: "sn", isSortable: true, alignment: { horizontal: "center" } },
    { title: translate("party_name", lang), prop: "name", isFilterable: true, isSortable: true },
    // { title: translate("Code", "np"), prop: "code", isFilterable: true, isSortable: true },
    { title: translate("short_name", lang), prop: "short_name", isFilterable: true, isSortable: true },
    { title: translate("election_symbol", lang), prop: "symbol", alignment: { horizontal: "center" } },
    // { title: translate("color", lang), prop: "color", alignment: { horizontal: "center" } },
  ];

  return (
    <div className="container political-party-list">
      <h3 className="political-party-list-title">{translate("party_list", lang)}</h3>
      <div className="">{data.length > 0 ? <DataTable headers={headers} data={data} filterColumn={["name_en", "name_np"]} sort={{ prop: "name", order: "asc" }} /> : <></>}</div>
    </div>
  );
};

export default Party;
